import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import AmountField from "components/AmountField";
import SectionBezel from "components/SectionBezel";
import CopyToClipboard from "components/CopyToClipboard";
import { getStripeDestination } from "utils/stripe";
import SERVICES from "utils/constants/services";
import DebounceTextarea from "components/DebounceTextarea";
import Token from "components/Token";
import Analytics, { COPY_SHIPPING_RATE_ID } from "utils/analytics";

const DetailsFields = ({ name }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const formattedPricePath = getFieldPath(name, "fixed_amount.formattedPrice");
  const currencyPath = getFieldPath(name, "fixed_amount.currency");

  const displayNamePath = getFieldPath(name, "display_name");
  const displayNameValue = get(values, displayNamePath);

  const idPath = getFieldPath(name, "id");
  const id = get(values, idPath);
  const editMode = Boolean(id);

  const formattedPriceValue = get(values, formattedPricePath);
  const currency = get(values, currencyPath);

  return (
    <SectionBezel
      header="Details"
      action={
        editMode
          ? {
              service: SERVICES.STRIPE,
              url: getStripeDestination({ path: `shipping-rates/${id}` })
            }
          : null
      }
    >
      <div className="pt3">
        <label className="f6 mb2 dib fw6">Display name</label>
        <DebounceTextarea
          inputValue={displayNameValue}
          placeholder="e.g. Ground Shipping"
          debounce={500}
          minRows={1}
          disabled={editMode}
          name={displayNamePath}
          valueSet={(val) => {
            setFieldValue(displayNamePath, val);
            if (!get(touched, displayNamePath)) {
              setTimeout(() => setFieldTouched(displayNamePath, true), 0);
            }
          }}
        />
        <div className="w-100 flex flex-column justify-between items-center">
          <div className="f5 w-100 pt3">
            <AmountField
              label="Amount"
              disabled={editMode}
              value={formattedPriceValue}
              name={formattedPricePath}
              currency={currency}
              currencyPath={currencyPath}
            />
          </div>
        </div>
        {editMode && (
          <Fragment>
            <div className="pt3">
              <label className="field__label fw5 db">ID</label>
              <div className="flex flex-row items-center">
                <CopyToClipboard
                  tooltip={`Copy id`}
                  toast="Copied id to clipboard"
                  value={id}
                  onClick={() => {
                    Analytics.track(COPY_SHIPPING_RATE_ID, {
                      id
                    });
                  }}
                />
                <Token value={id} />
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </SectionBezel>
  );
};

export default DetailsFields;
